var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDividendYield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #042b62;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M536.44,260.45c0,58.02-.06,116.05.02,174.07.08,62.52,43.58,105.88,106.32,105.91,118.17.06,236.34.13,354.5-.2,9.5-.03,12.34,2.13,11.93,11.97-5.76,138.56-59.78,254.31-164.1,345.79-74.05,64.93-160.85,103.28-258.72,112.22-162.47,14.85-299.25-39.27-407.73-161.48-60.82-68.51-98.58-149.21-109.64-239.94-22.8-187.06,41.68-339.04,192.59-452.32,70.44-52.87,151.25-80.82,239.32-87.01,8.76-.62,17.57-.7,26.28-1.69,7.41-.85,9.49,1.61,9.41,9.11-.38,39.38-.18,78.77-.18,118.16,0,21.8,0,43.61,0,65.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.98,275.87c0-52.4-.03-104.81.01-157.21.02-28.71,18.89-44.06,46.29-36.34,179.75,50.69,294.63,166.31,344.84,346.07,6.91,24.74-8.75,44.47-34.48,44.49-106.57.09-213.15.07-319.72.01-23.09-.01-36.87-13.71-36.9-36.66-.09-53.46-.03-106.92-.03-160.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividendYield);
export default __webpack_public_path__ + "static/media/DividendYield.0394857ee4b0a04f02859670fb0d2e5b.svg";
export { ForwardRef as ReactComponent };